import React, { useState, useEffect } from 'react';
import Input from '../../components/UI/Input/Input'
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import Classes from './style.css';
import Button from "../../components/UI/Button/Button";

export const SearchComponent = ({
    storesList,
    translations, isRequestingStoresList,
    setBookingInfo, onSearchClicked,
    hasErrorStoresListRequest,
    hasErrorRequestBookingInfo,
    history
}) => {
    const [bookingCodeInput, setBookingCodeInput] = useState('');
    const [storeSelected, setStoreSelected] = useState('');

    useEffect(() => {
        if (storesList.length > 0) {
            setStoreSelected(storesList[0].id);
        }
    }, [storesList.length]);

    let errorMessage = '';
    if (hasErrorStoresListRequest) {
        errorMessage = translations.label_error_server;
    } else if (hasErrorRequestBookingInfo) {
        errorMessage = translations.label_search_booking_wrong_details;
    }

    let component = null;
    if (isRequestingStoresList) {
        component = <LogoLoader />
    } else {
        component = <div>
            <div className={Classes.SearchRestaurantContainer}>
                <label htmlFor="search-country-select" className={Classes.SearchLabel}>
                    {translations.label_select_booking_restaurant}:
                </label>
                <select
                    value={storeSelected}
                    onChange={e => setStoreSelected(e.target.value)}
                    className={Classes.SelectCountry}
                    id="search-country-select"
                >
                    {storesList.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                </select>
            </div>
            <Input
                value={bookingCodeInput}
                label={translations.label_booking_reference}
                elementType='input'
                elementConfig={{
                    type: 'text',
                    placeholder: translations.label_enter_booking_reference_code
                }}
                changed={e => setBookingCodeInput(e.target.value)}
                touched={false}
                focused={false}
                translations={translations}
                setReference={() => { }}
            />
            {errorMessage && <p className={Classes.ErrorMessage}>{errorMessage}</p>}
            <div className={Classes.ButtonsContainer}>
                <div className={Classes.ButtonContainer}>
                    <Button
                        btnLabel={translations.label_search_booking}
                        disabledButton={!bookingCodeInput || !storeSelected}
                        clicked={() => {
                            console.log(bookingCodeInput, storeSelected);
                            setBookingInfo(bookingCodeInput.toUpperCase(), storeSelected);
                            onSearchClicked(bookingCodeInput.toUpperCase(), storeSelected);
                        }}
                    />
                </div>
                <div className={Classes.ButtonContainer}>
                    <Button
                        negative
                        btnLabel={translations.label_cancel}
                        clicked={() => {
                            history.replace('/');
                        }}
                    />
                </div>
            </div>
        </div>
    }
    return (
        <React.Fragment>
            <div className={Classes.ContentContainer}>
                {component}
            </div>
        </React.Fragment>
    );
}


// WEBPACK FOOTER //
// ./src/containers/EditBooking/SearchComponent.js